import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  MotifErrorMessage,
  MotifFormField,
  MotifInput,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifOption,
  MotifProgressLoader,
  MotifSelect,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import Button from "@/components/Form/Button/Button";
import "./FormModal.scss";
import { renderOptionList } from "../Form/calculationSummaryHelper";
import {
  useCreateStepClassFilterApiMutation,
  useGetClassListBySchemeQuery,
  useGetSchemeVersionListByCaseQuery,
} from "../calculationStepReducer";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import {
  CANCEL_BUTTON_VARIANT,
  SAVE_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { isNumeric } from "@/utility/validation";
import { getNumbersAndDecimals } from "@/utility/common";

type Props = {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  formData?: any | null;
  caseId: string;
  stepId: string;
  selectedClass: string[];
  setIsRefetch: Dispatch<SetStateAction<boolean>>;
  setSelectedClassId: Dispatch<SetStateAction<string>>;
  isNew: boolean;
  selectedScheme: string | undefined;
  setIsNew: any;
};

export default function FormModalClassFilterNew({
  isVisible,
  setIsVisible,
  stepId,
  caseId,
  setIsRefetch,
  setSelectedClassId,
  selectedClass,
  isNew,
  setIsNew,
  selectedScheme,
}: Props) {
  const { t } = useTranslation();
  const [showMessage, setShowMessage] = useState({
    show: false,
    type: "error",
    message: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [childOptions, setChildOptions] = useState<any>([
    {
      label: t("global.globalActions.optionDefault"),
      value: "",
    },
  ]);
  const [isVisibleCancel, setIsVisibleCancel] = useState(false);
  const { data, isLoading: isLoadingData } =
    useGetSchemeVersionListByCaseQuery(caseId);

  const [schemeList, setSchemeList] = useState<any>([
    {
      label: t("global.globalActions.optionDefault"),
      value: "",
    },
  ]);

  let [formData, setFormData] = useState<any>({
    scheme: "",
    class: "",
    weightingFactor: "1",
  });

  useEffect(() => {
    setFormData({
      scheme: selectedScheme ? selectedScheme : "",
      class: "",
      weightingFactor: "1",
    });
    setIntialState(
      JSON.stringify({
        scheme: selectedScheme ? selectedScheme : "",
        class: "",
        weightingFactor: "1",
      })
    );
  }, [selectedScheme, schemeList]);
  const [intialState, setIntialState] = useState(JSON.stringify(formData));
  const [formValidation, setFormValidation] = useState<any>({
    scheme: "",
    class: "",
    weightingFactor: "",
  });

  const {
    data: schemeData,
    isLoading: schemaIsloading,
    isFetching: schemaFetching,
  } = useGetClassListBySchemeQuery(formData.scheme, {
    skip: formData.scheme === "" || formData.scheme === undefined,
  });

  useEffect(() => {
    if (data && data.length > 0) {
      const schemeList = renderOptionList(data, "name", "schemeVersionId", {
        label: t("global.globalActions.optionDefault"),
        value: "",
      });
      setFormData({ scheme: "", class: "", weightingFactor: "1" });
      setSchemeList(schemeList);
    }
  }, [data, t]);

  /* Child Dropdown */
  useEffect(() => {
    if (schemeData) {
      const filterClasses = schemeData.filter((item: any) => {
        if (
          selectedClass === undefined ||
          selectedClass?.length === 0 ||
          selectedClass === null
        ) {
          return true;
        }
        if (selectedClass.includes(item.id)) {
          return false;
        }
        return true;
      });

      const classList = renderOptionList(filterClasses, "name", "id", {
        label: t("global.globalActions.optionDefault"),
        value: "",
      });
      setChildOptions(classList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schemeData]);
  /* Child Dropdown */
  let [createStepClassFilterApi] = useCreateStepClassFilterApiMutation();
  function handleValidation() {
    let formDetails: any = { ...formData };
    let formValidationObj = {
      scheme: !formDetails?.scheme
        ? "pages.distributions.distributionStepsTab.classFilterTab.schemeReq"
        : "",
      class: !formDetails?.class
        ? "pages.distributions.distributionStepsTab.classFilterTab.classReq"
        : "",
      weightingFactor: !formDetails?.weightingFactor
        ? "pages.distributions.distributionStepsTab.classFilterTab.weightingFactorReq"
        : "",
    };
    let flag = true;
    for (let element in formDetails) {
      if (!formDetails?.[element] && flag) {
        flag = false;
      }
    }
    const weightFactorValue: any = isNumeric(formDetails?.weightingFactor);
    if (!weightFactorValue && formDetails?.weightingFactor) {
      formValidationObj.weightingFactor =
        "pages.distributions.distributionStepsTab.classFilterTab.weightingFactorReqNum";
      flag = false;
    }
    setFormValidation({ ...formValidationObj });
    return flag;
  }
  const onSubmit = async () => {
    if (handleValidation()) {
      setIsLoading(true);

      try {
        const formClassData: any = formData;
        let postData = {
          classId: formClassData?.class,
          weight: Number(formClassData?.weightingFactor),
        };
        // @ts-ignore
        const responseApi = await createStepClassFilterApi({
          ...postData,
          caseId: caseId,
          calculationStepId: stepId,
        });

        if (responseApi.hasOwnProperty("data")) {
          setIsRefetch(true);
          setIsVisible(false);
          setIsLoading(false);
          setSelectedClassId("");
          setIsNew(false);
        } else {
          const error = t("global.globalNotifications.unExpectedError");
          setShowMessage({
            ...showMessage,
            show: true,
            type: "error",
            message: t(error),
          });
          setIsLoading(false);
          setSelectedClassId("");
        }
      } catch (error) {
        setShowMessage({ ...showMessage, show: true, type: "error" });
      }
    }
  };
  if (isLoadingData) {
    return <MotifProgressLoader show={true} />;
  }

  /* Child Dropdown */
  const cancelBtnApproveHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisible(false);
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
    setIsNew(false);

    // setIsEdit(false);
  };

  const cancelBtnRejectHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };
  function handleOnChange(e: any, keyname: string) {
    setFormData({ ...formData, [keyname]: e });
  }
  function handleOnChangeWeightFactor(e: any, keyname: string) { 
    // Allow only numbers and decimal points, with a maximum of 13 digits before the decimal and 8 digits after
    if (/^-?\d{0,13}(?:\.\d{0,8})?$/.test(e.target.value)) {
      let digitAfterDecimal = 8;
      let value = e.target.value;
      const digitAfterDecimalCurrent = getNumbersAndDecimals(value);
      let number = value?.split(".")[0];
      number = number?.replace(/-/g, "");
      if (number.length >= 9) {
        digitAfterDecimal = 3;
      }
      if (digitAfterDecimalCurrent > digitAfterDecimal) {
        const decimalIndex = value.indexOf(".");
        value = value.toString().slice(0, decimalIndex + digitAfterDecimal + 1);
      }
      setFormData({ ...formData, [keyname]: value });
    }
  }
  function stopAutoFilling() {
    //this function is used to stop auto filling of password fields
    return (
      <MotifInput
        //@ts-ignore
        autoComplete="new-password"
        style={{ display: "none" }}
        type="password"
      ></MotifInput>
    );
  }
  return (
    <>
      <MotifModal
        onClose={() => {
          if (intialState !== JSON.stringify(formData)) {
            setIsVisibleCancel(true);
          } else {
            setIsVisible(false);
            setIsVisibleCancel(false);
            setShowMessage({ ...showMessage, show: false, type: "error" });
            setIsNew(false);
          }
        }}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        {schemaIsloading && <MotifProgressLoader show={true} />}
        <div className="formModalWrapper">
          <MotifModalHeader>
            <span className="discard_heading">
              {t(
                "pages.distributions.distributionStepsTab.classFilterTab.classFilterCreateTitle"
              )}
            </span>
          </MotifModalHeader>
          <MotifModalBody>
            <div className="formModal">
              {stopAutoFilling()}
              <div className="motif-row mar-t-20">
                <div className="motif-col-md-5">
                  <div className="formFieldLabel">
                    <label
                      htmlFor="input"
                      aria-label={t(
                        "pages.distributions.distributionStepsTab.classFilterTab.scheme"
                      )}
                    >
                      {t(
                        "pages.distributions.distributionStepsTab.classFilterTab.scheme"
                      )}
                      {<span className="requiredSymbol">*</span>}
                    </label>
                  </div>
                  <MotifFormField>
                    <MotifSelect
                      ariaLabelledBy="select-label"
                      onChange={(e) => handleOnChange(e, "scheme")}
                      value={formData.scheme}
                      searchPlaceholder={t(
                        "global.globalPlaceholder.searchPlaceHolder"
                      )}
                      visibleOptions={5}
                      placeholder={t("global.globalPlaceholder.pleaseSelect")}
                      disabled={selectedScheme ? true : false}
                    >
                      {schemeList.map((option: any) => (
                        <MotifOption
                          selected={option.value === formData.scheme}
                          key={option.value}
                          disabled={option.value === "" ? true : false}
                          value={option.value}
                        >
                          {option.label}
                        </MotifOption>
                      ))}
                    </MotifSelect>
                  </MotifFormField>
                  {formValidation?.scheme && !formData?.scheme && (
                    <MotifErrorMessage>
                      {t(formValidation?.scheme)}
                    </MotifErrorMessage>
                  )}
                </div>
              </div>
              <div className="motif-row mar-t-20">
                <div className="motif-col-md-5">
                  <div className="formFieldLabel">
                    <label
                      htmlFor="input"
                      aria-label={t(
                        "pages.distributions.distributionStepsTab.classFilterTab.class"
                      )}
                    >
                      {t(
                        "pages.distributions.distributionStepsTab.classFilterTab.class"
                      )}
                      {<span className="requiredSymbol">*</span>}
                    </label>
                  </div>
                  {/* Child Dropdown */}
                  <MotifFormField>
                    <MotifSelect
                      ariaLabelledBy="select-label"
                      onChange={(e) => handleOnChange(e, "class")}
                      value={formData.class}
                      searchPlaceholder={t(
                        "global.globalPlaceholder.searchPlaceHolder"
                      )}
                      visibleOptions={3}
                      placeholder={t("global.globalPlaceholder.pleaseSelect")}
                    >
                      {childOptions.map((option: any) => (
                        <MotifOption
                          key={option.value}
                          disabled={option.value === "" ? true : false}
                          value={option.value}
                        >
                          {option.label}
                        </MotifOption>
                      ))}
                    </MotifSelect>
                  </MotifFormField>

                  {formValidation?.class && !formData?.class && (
                    <MotifErrorMessage>
                      {t(formValidation?.class)}
                    </MotifErrorMessage>
                  )}

                  {schemaFetching && (
                    <>
                      <br></br>
                      <MotifProgressLoader
                        size="xs"
                        variant="circular"
                      ></MotifProgressLoader>
                    </>
                  )}
                  {/* Child Dropdown */}
                </div>
              </div>

              <div className="motif-row mar-t-20">
                <div className="motif-col-md-5">
                  <div className="formFieldLabel">
                    <label
                      htmlFor="input"
                      aria-label={t(
                        "pages.distributions.distributionStepsTab.classFilterTab.weightFactor"
                      )}
                    >
                      {t(
                        "pages.distributions.distributionStepsTab.classFilterTab.weightFactor"
                      )}
                      {<span className="requiredSymbol">*</span>}
                    </label>
                  </div>
                  <MotifFormField>
                    <MotifInput
                      //@ts-ignore
                      type="text"
                      hideClearButton={true}
                      value={formData.weightingFactor}
                      maxLength="100"
                      onChange={(e: any) =>
                        handleOnChangeWeightFactor(e, "weightingFactor")
                      }
                      // placeholder={placeholder}
                      // disabled={readonly}
                    />
                  </MotifFormField>
                  {formValidation?.weightingFactor &&
                    (!formData?.weightingFactor ||
                      !isNumeric(formData?.weightingFactor)) && (
                      <MotifErrorMessage>
                        {t(formValidation?.weightingFactor)}
                      </MotifErrorMessage>
                    )}
                </div>
              </div>
            </div>
            <div>
              <MotifErrorMessage>
                {showMessage.show && showMessage.message}
                {/* {errorList.length > 0 &&
                    t(
                      "pages.distributions.distributionStepsTab.classFilterTab.validationMessage",
                      { fieldNames: errorsShow }
                    )} */}
              </MotifErrorMessage>
            </div>
          </MotifModalBody>
          <MotifModalFooter>
            <div className="button-container-add">
              <Button
                variant={SAVE_BUTTON_VARIANT}
                label={t("global.globalActions.save")}
                loading={isLoading}
                disabled={isLoading}
                type="button"
                onClickHandler={() => onSubmit()}
              />
              <Button
                label={t("global.globalActions.cancel")}
                type="button"
                variant={CANCEL_BUTTON_VARIANT}
                className="cancelBtn"
                onClickHandler={() => {
                  if (intialState !== JSON.stringify(formData)) {
                    setIsVisibleCancel(true);
                  } else {
                    setIsNew(false);
                    setIsVisible(false);
                    setIsVisibleCancel(false);
                    setShowMessage({
                      ...showMessage,
                      show: false,
                      type: "error",
                    });
                  }
                }}
              />
            </div>
          </MotifModalFooter>
        </div>
      </MotifModal>
      <ConfirmationModal
        isVisible={isVisibleCancel}
        setIsVisible={setIsVisibleCancel}
        cancelBtnApproveHandler={cancelBtnApproveHandler}
        cancelBtnRejectHandler={cancelBtnRejectHandler}
      />
    </>
  );
}
